import {get, set, toPath} from 'lodash';
import schema from './order_db';
import * as utils from "./utils";
import {edit} from './sample';
import i18n from 'src/i18n/index';
import * as Subprofile from './subprofile';
import debug from 'src/debug';
import moment from 'moment/moment';
import {DatePicker} from 'element-ui';

export function title(model) {
  let p = get(model, 'subProfile');
  if (p) {
    return Subprofile.title.call(this, p, Subprofile);
  }
  return p || i18n.s('schema.order');
}

export const columns = utils.columnsFn(schema);

export const list = utils.listFn('getOrders', function (payload) {
  if (get(this, 'schemaParams.created_at')) {
    payload.created_at = {
      $gte: +moment(this.schemaParams.created_at).startOf('month'),
      $lte: +moment(this.schemaParams.created_at).endOf('month'),
    };
  }
  return payload;
});
export const view = utils.viewFn('/admin/orders/:id');
export const read = utils.readFn('getOrderById', 'order_id');
// export const create = utils.createFn('/admin/orders/create');

export {edit};

export function tableFilters(schema) {
  if (this.schemaParams) {
    this.schemaParams.created_at = null;
    return [
      h => h(DatePicker.name, {
        props: {
          value: this.schemaParams.created_at,
          type: 'month',
          placeholder: i18n.fr('label_pick_a_month'),
        },
        on: {
          input: v => {
            this.schemaParams.created_at = v;
            this.queryChanged();
          },
        },
      }),
    ];
  }
  return [];
}

export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      class: 'btn-success',
      validation: true,
      action: utils.updateFn('updateOrderAsAdmin', 'order_id', [
        'available_tickets',
        'total_tickets',
        'details',
        'custom_ids',
        'subProfile',
        'expiry_date',
        'status',
        'service_location',
        'emergency_contact',
      ]),
    });
    if (debug.DEBUG) {
      temp.push({
        label: i18n.fr('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: e => e.keyCode === 46,
        action: utils.formActions.delete('deleteOrderById', 'order_id', '/admin/orders'),
      });
    }
  }
  if (model.created_by) {
    temp.push({
      label: i18n.fr('action.create_$obj', {obj: '${i18n.schema.appointment}'}),
      class: 'btn-info',
      validation: false,
      action(model, schema) {
        this.$router.push('/admin/appointments/create?order_id=' + model.order_id);
        return Promise.resolve();
      },
    });
    temp.push({
      label: i18n.fr('action.create_$obj', {obj: '${i18n.schema.rapid_payment}'}),
      class: 'btn-info',
      validation: false,
      action(model, schema) {
        this.$router.push('/admin/transactions/standalone?type=rapid&order_id=' + model.order_id);
        return Promise.resolve();
      },
    });
    temp.push({
      label: i18n.fr('schema.refund_transaction'),
      class: 'btn-info',
      validation: false,
      action(model, schema) {
        this.$router.push('/admin/transactions/standalone?type=refund&order_id=' + model.order_id);
        return Promise.resolve();
      },
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}

export function listActions(schema, readonly) {
  let temp = [];
  temp.push({
    label: i18n.fr('action.export_data'),
    action: utils.exportFn({
      'order_id': 'Order ID',
      'created_by_name': 'Creator',
      'status': 'Status',
      'created_at': 'Created At',
      'updated_at': 'Updated At',
      'required_groups.0.group.details.code': 'Type of Service',
      'service_dates': 'Service Dates',
      'total_tickets': 'Total Tickets',
      'available_tickets': 'Available Tickets',
      'unit_amount': 'Unit Amount',
      'location_fee': 'Location Fee',
      'expiry_date': 'Expired At',
    }, async function (row, fields) {
      row.created_by_name = get(row, 'created_by.details.profile.last_name', '') + ' '
        + get(row, 'created_by.details.profile.first_name', '');
      row.service_dates = get(row, 'appointments', [])
        .map(x => moment(get(x, 'details.service_date')))
        .filter(x => x.isValid())
        .map(x => x.format('DD/MM/YYYY'))
        .join('\n');

      let filter = x => {
        for (let k in fields) {
          k = toPath(k);
          if (get(x, k) == null) {
            set(x, k, '');
          }
        }
      };

      filter(row);
      return row;
    }),
  });
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/order.js